import { API_URL, LIVE } from '../../common/variables';

export const FETCHING_PLANS = 'FETCHING_PLANS';
export const SET_PLANS = 'SET_PLANS';
export const ERROR_PLANS = 'ERROR_PLANS';

export const fetchingPlans = (fetching) => ({
  type: FETCHING_PLANS,
  payload: fetching,
});

export const receivedPlans = (plans) => ({
  type: SET_PLANS,
  payload: plans,
});

export const receivedError = (error) => ({
  type: ERROR_PLANS,
  payload: error,
});

export const fetchPlans = () => {
  return (dispatch, getState) => {
    dispatch(receivedError(false));
    dispatch(fetchingPlans(true));
    return fetch(API_URL + '/subscriptions/plans', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        if (res.status === 200) {
          res.json().then((plans) => {
            dispatch(fetchingPlans(false));
            dispatch(receivedPlans(plans.sort((a, b) => a.amount - b.amount)));
          });
        } else {
          dispatch(fetchingPlans(false));
        }
      })
      .catch((error) => {
        dispatch(fetchingPlans(false));
        dispatch(receivedError(true));
        // console.log(error);
      });
  };
};
